import { useSelector } from "react-redux";
import PageNotFound from "../../pages/PageNotFound";
import { accountSelector } from "../../store";
import { SubscriptionType } from "../../types/Shared";

interface RequireSubscriptionProps {
  children: React.ReactNode;
  subscription: SubscriptionType;
}
const RequireSubscription = ({
  children,
  subscription,
}: RequireSubscriptionProps) => {
  const { data: accountInfo } = useSelector(accountSelector);

  if (!accountInfo?.subscriptions.includes(subscription)) {
    return (
      <PageNotFound
        statusCode="401"
        title="Subscription Required"
        subtitle="Your Account is not subscribed to this feature yet."
      />
    );
  }

  return <>{children}</>;
};

export default RequireSubscription;
